// src/components/NavTabs.jsx
import { NavLink } from 'react-router-dom';
import '../styles/about.css';

export default function NavTabs({ tabs }) {
  return (
    <section className="about-nav">
      <div className="container">
        <div className="nav-tabs">
          {tabs.map((t, i) => (
            <NavLink
              key={i}
              to={t.path}
              className={({ isActive }) => 'nav-tab' + (isActive ? ' active' : '')}
            >
              {t.label}
            </NavLink>
          ))}
        </div>
      </div>
    </section>
  );
}
